import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import Config from '../../../config';
import { setBackHandler, setHeaderTitle } from '../../../helpers/header.helper';
import setToast from '../../../helpers/toaster.helper';
import { AlertInfoIcon, BirdLogo, InfoCircleIcon, InformationDarkScheduleIcon, IntegrationIcon, TeamsIntRectIcon } from '../../../icon';
import { IntegrationSetupService } from '../../../services/IntegrationSetup';
import { UserService } from '../../../services/UserService';
import { AppRoutes, WebRoutes } from '../../routes/route.path';
import ButtonComponent from '../../shared/button/button.component';
import { buttonLabels, pageTitles } from '../../shared/constants';
import { ToasterType } from '../../shared/toaster/toaster.model';
import IntegrateChannels from './integrate-channels';

type Props = {}

interface ConsentModal {
	orgId: string;
	name: string;
	integrationCode: string;
	integrationStatus: boolean;
}

const MSTeamsChannelSetup = (props: Props) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [permission, setPermission] = useState<boolean>(false)
	const [loading, setLoading] = useState<boolean>(false);

	const setAdminConsent = (data: ConsentModal) => {
		IntegrationSetupService.updateIntegrationStatus(data)
			.then((res) => {
				setPermission(data.integrationStatus)
				setToast("Updated sucessfully", ToasterType.SUCCESS)
			})
			.catch((err) => {
				setPermission(permission)
			})
	}

	useEffect(() => {
		setLoading(true);
		const params = new URLSearchParams(location.search);
		if (params.get('connection') === 'true') {
			setPermission(true)
			setLoading(false);
		}
		else if (params.get('admin_consent') === 'True') {
			setPermission(true)
			setLoading(false);
			setAdminConsent({
				orgId: UserService.getCurrentUserOrgId(),
				name: "MSTeams",
				integrationCode: IntegrationSetupService.MicrosoftTeams_Code,
				integrationStatus: params.get('admin_consent') === 'True'
			})
		}
		else {
			setPermission(false);
			setLoading(false);
		}
	}, [location.search])

	useEffect(() => {
		setHeaderTitle(pageTitles.MS_TEAMS_SETUP);
		setBackHandler(() => navigate(AppRoutes.INTEGRATIIONS))
	}, [])

	const handleAdminConsent = () => {
		// const clientId = '58ac1cc5-e859-46c2-bea9-db7ed8aa3f8e';
		const clientId = Config.TEAMS_CHANNEL_CLIENT_ID;
		// const clientSecret = 'Wmy8Q~hmvZwlOezwA0oh7tqYBgh.nDorNuu2Wdv9';
		// const tenantId = 'edb4c8cb-528b-440e-a593-0869c59f1018';
		const scope = 'https://graph.microsoft.com/.default';
		const redirectUri = `${Config.APP_FE_URL}${WebRoutes.TEAMS_CHANNEL_SETUP}`
		const responseType = 'code';

		const permissionUrl = `https://login.microsoftonline.com/common/adminconsent?client_id=${clientId}&scope=${scope}&redirect_uri=${redirectUri}&response_type=${responseType}`;
		// const permissionUrl = `https://login.microsoftonline.com/${tenantId}/v2.0/adminconsent?client_id=${clientId}&scope=${scope}&redirect_uri=${redirectUri}&response_type=${responseType}`;

		// Redirect to the admin consent URL
		window.location.href = permissionUrl;
	};

	return (
		<>
			{/* <div className='d-flex w-p-100 h-p-100 bg-color-profile-primary-background'>
				<div className="d-flex flex-direction w-fill h-fill m-1 bg-color-secondary br-5">
					<div className="d-flex w-fill bg-color-integrate-ms-teams-header brt-5">
						<span className="mt-3"><TeamsIntRectIcon /></span>
						<span className="h1-semibold my-auto">Microsoft Teams</span>
						<span className="my-auto mx-2"><IntegrationIcon /></span>
						<span className="my-auto mx-2"><BirdLogo /></span>
						<div className="d-flex my-auto ml-auto">
							<ButtonComponent Variant={permission ? "secondary-btn" : "primary-btn"}
								OnClick={permission ? () => setAdminConsent({
									orgId: UserService.getCurrentUserOrgId(),
									name: "MSTeams",
									integrationCode: IntegrationSetupService.MicrosoftTeams_Code,
									integrationStatus: false
								}) : handleAdminConsent}
								Type="button"
								ButtonLabel={loading ? "" : permission ? buttonLabels.DISCONNECT : buttonLabels.REQUEST_CONSENT}
								Loading={loading}
							/>
							<span className="my-auto mx-2"><InfoCircleIcon /></span>
						</div>
					</div>
					<div className="d-flex bg-color-secondary justify-around w-p-100 my-2 flex-wrap h-v-60 o-y-scroll">
						<IntegrateChannels organizationId={UserService.getCurrentUserOrgId()} isAdminConcentSucess={permission} />
					</div>
				</div>
			</div> */}
			<div className='d-flex w-p-100 h-p-100 '>
				<div className="d-flex flex-direction w-fill h-p-100 mx-2 br-5 integrate-card-border">
					<div className="d-flex flex-direction h-p-20 bg-color-integrate-ms-teams-header brt-5 pb-2">
						<div className='d-flex  align-center h-15 justify-between mx-auto mx-3'>
							<div className='d-flex align-center'>
								<span className=""><TeamsIntRectIcon /></span>
								<span className="mx-2"><IntegrationIcon /></span>
								<span className="mx-2"><BirdLogo /></span>
							</div>
							<div className="d-flex my-auto ">
								<ButtonComponent Variant={permission ? "danger-btn" : "primary-btn"}
									OnClick={permission ? () => setAdminConsent({
										orgId: UserService.getCurrentUserOrgId(),
										name: "MSTeams",
										integrationCode: IntegrationSetupService.MicrosoftTeams_Code,
										integrationStatus: false
									}) : handleAdminConsent}
									Type="button"
									ButtonLabel={loading ? "" : permission ? buttonLabels.DISCONNECT : buttonLabels.REQUEST_CONSENT}
									Loading={loading}
								/>
							</div>
						</div>
						<div className='d-flex align-center bg-color-integration-info-bg ml-3 py-1 px-2 br-5 mx-auto'>
							<AlertInfoIcon />
							<div className='h6-regular ml-1'>
								Messages received in an inbox will appear in the MS Teams channel you specify. Channel members can reply to the message from Teams.
							</div>
						</div>
					</div>
					<div className="d-flex flex-direction w-p-100 h-p-80">
						<IntegrateChannels organizationId={UserService.getCurrentUserOrgId()} IsAdminConcentSucess={permission} />
					</div>
				</div>
			</div>
		</>
	)
}

export default MSTeamsChannelSetup